export const PTO_PHASE_TWO_SPOTLIGHT_TARGET = 'pto-phase-two-spotlight';

export const getIsPremiumOnboardingHappened = (initialLoading = false): boolean => {
	return initialLoading
		? localStorage.getItem(PTO_PHASE_TWO_SPOTLIGHT_TARGET) === null
		: localStorage.getItem(PTO_PHASE_TWO_SPOTLIGHT_TARGET) === 'false';
};

export const setIsPremiumOnboardingHappened = (isPremiumOnboardingHappened: boolean): boolean => {
	try {
		localStorage.setItem(PTO_PHASE_TWO_SPOTLIGHT_TARGET, String(isPremiumOnboardingHappened));
		return true;
	} catch (err) {
		return false;
	}
};
